import { render, staticRenderFns } from "./ModalNotificationEdit.vue?vue&type=template&id=c8cc43ee&scoped=true&lang=pug"
import script from "./ModalNotificationEdit.vue?vue&type=script&lang=ts"
export * from "./ModalNotificationEdit.vue?vue&type=script&lang=ts"
import style0 from "./ModalNotificationEdit.vue?vue&type=style&index=0&id=c8cc43ee&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8cc43ee",
  null
  
)

export default component.exports